import styled from 'styled-components'
import { Modal as ModalAntd } from 'antd'

export const ModalWrapper = styled(ModalAntd)`
  --height: 400px;
  --header-height: 32px;
  --footer-height: 50px;
  --padding: calc(20px * 2);
  --body-height: calc(var(--height) - var(--header-height) - var(--footer-height) - var(--padding));

  .ant-modal-content {
    height: var(--height);

    .ant-modal-body {
      height: var(--body-height);
    }

    .ant-modal-footer {
      height: var(--footer-height);
    }
  }

  .filter {
    position: sticky;
    top: 0;
    background: #fff;
    padding-bottom: 4px;

    .search {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      border-radius: 4px;
      border: 1px solid #ccc;
      width: 100%;

      input {
        width: 100%;
        padding: 0.5rem;
        border: none;
        outline: none;
      }

      button {
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 0.5rem;
        color: #8c8c8c;
      }
    }
  }

  .content-wrapper {
    overflow-y: auto;
    height: var(--body-height);
  }

  .requester-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0;
    cursor: pointer;
    transition-property: padding-left background;
    transition-duration: 0.2s;

    &:hover {
      background: #f4f4f4;
      padding-left: 0.5rem;
    }
  }

  .footer {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
  }
`
